import React, { useContext } from 'react';
import { Pie } from 'react-chartjs-2';
import PropTypes from 'prop-types';

import styles from './styles.module.css';

import DashboardContext from '#/context';
import useWidget from '#/hooks/useWidget';
import NotFound from '#/components/NotFound';
import Loader from '#/components/Loader';

function PieChart({ dashboardWidgetId, endpoint, widgetBindDtos, auxiliaryOptionsDto }) {
  const { filters, localFilters, date, polling } = useContext(DashboardContext);
  const { serviceData } = useWidget(
    endpoint,
    filters,
    localFilters,
    date,
    polling,
    dashboardWidgetId,
    null,
    null,
    widgetBindDtos, 
    auxiliaryOptionsDto
  );

  function getTotal() {
    let datasets = serviceData.datasets
    if (datasets && datasets.length) return datasets[0].data.reduce((a,b) => a + b, 0)
  }

  function renderPieChart() {
    return Object.keys(serviceData).length > 0 ? (
      <>
        {
          serviceData.datasets && serviceData.datasets.length && (
            <div className={styles.wrapper}>
              <span className={styles.label}>Total: </span>
              <span>{getTotal()}</span>
            </div>
          )
        }
        <Pie
          data={serviceData}
          options={{
            maintainAspectRatio: false,
            legend: {
              position: 'bottom',
              labels: {
                usePointStyle: true,
                padding: 20,
                fontSize: 13,
                boxWidth: 8,
              },
            },
            layout: {
              padding: {
                top: 16,
                left: 16,
                right: 16,
                bottom: 16
              },
            },
            tooltips: {
              appa: {
                opacity: 0,
                legendColorBackground: 'red',
              },
              callbacks: {
                title: (tooltipItem, data) => data.labels[tooltipItem[0].index],
                label: (tooltipItem, data) => {
                  const dataset = data.datasets[tooltipItem.datasetIndex];
                  const meta = dataset._meta[Object.keys(dataset._meta)[0]];
                  const currentValue = dataset.data[tooltipItem.index];
                  const percentage = parseFloat(
                    ((currentValue / meta.total) * 100).toFixed(1)
                  );
                  return ` ${percentage}% (${
                    data.datasets[0].valueFormated
                      ? data.datasets[0].valueFormated[tooltipItem.index]
                      : currentValue
                  })`;
                },
              },
            },
          }}
        />
      </>
    ) : (
      <NotFound />
    );
  }

  return serviceData ? renderPieChart() : <Loader />;
}

PieChart.propTypes = {
  endpoint: PropTypes.shape({
    endpointType: PropTypes.string,
    endpointUrl: PropTypes.string,
  }),
};

export default PieChart;
